// Настройки инстанса (GET /api/settings) — единственная точка чтения для всей витрины.
//
// Зачем: настройки читали семь мест, каждое своим запросом со своим кэшем. На холодном
// открытии приложения это семь одинаковых запросов подряд, а у двух модулей (legal,
// catalogLabels) неудачный запрос залипал навсегда — до перезагрузки страницы показывались
// дефолты. Здесь один запрос в полёте на всех, и неудача не кэшируется.
//
// Свежесть: по умолчанию ответ считается актуальным 10 секунд. Этого хватает, чтобы
// схлопнуть пачку обращений при старте, и при этом корзина, открытая позже, увидит
// изменённые владельцем ставки и минимальную сумму заказа без перезагрузки.
// Тем, кому свежесть не нужна (подписи разделов, горизонт каталога, слоты, ссылки на
// документы), передают maxAgeMs: FOREVER — читают ровно один раз за сессию.
import { api } from './api';

export const DEFAULT_MAX_AGE_MS = 10000;
export const FOREVER = Number.POSITIVE_INFINITY;

let cache = null;      // последний успешный ответ
let cachedAt = 0;
let pending = null;    // запрос в полёте: параллельные вызовы ждут его, а не шлют свой

/** Последний успешный ответ без ожидания сети; null — ещё ни разу не загружали. */
export function getAppSettingsCached() {
  return cache;
}

/**
 * Настройки инстанса. Повторный вызов внутри `maxAgeMs` отдаёт тот же объект без запроса;
 * параллельные вызовы разделяют один запрос. Ошибка пробрасывается вызывающему (у каждого
 * свои дефолты) и не запоминается — следующий вызов попробует снова.
 */
export function fetchAppSettings({ maxAgeMs = DEFAULT_MAX_AGE_MS } = {}) {
  // Строгое «моложе, чем»: maxAgeMs = 0 значит «нужны свежие», а не «сойдут этой же миллисекунды»
  if (cache && (Date.now() - cachedAt) < maxAgeMs) return Promise.resolve(cache);
  if (!pending) {
    pending = api.getSettings()
      .then((s) => {
        cache = s || {};
        cachedAt = Date.now();
        pending = null;
        return cache;
      })
      .catch((e) => {
        pending = null;
        throw e;
      });
  }
  return pending;
}

/** Только для тестов: забыть загруженное. */
export function _resetAppSettings() {
  cache = null;
  cachedAt = 0;
  pending = null;
}
